import '../../styles/style.css'
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next"

export default function ServiceCard({ title, paragraph, icon }) {

    const { t } = useTranslation();

    return (

        <div data-aos="fade-right" className={"item"}>

            <div className={"layer"}>

                <h3>{title}</h3>
                <p>{paragraph}</p>
                <span><i className={icon}></i></span>

            </div>

            <div className={"item-request"}>
                <p>{t("starting.text")}</p>
                <Link to="/contact">{t("service-request.text")}</Link>
            </div>

        </div>

    );
};